export default function WaitingCallback({ waitingCallback, waitingCallbackInfo }: { waitingCallback: boolean, waitingCallbackInfo?: any }) {


    if (waitingCallback) {
        return (
            <section className="px-4 py-10 flex flex-col items-center justify-center text-center">
                <h3 className="text-2xl font-bold text-purple-900 mb-2">
                    {"Venter på at agenten skal motta samtalen"}
                </h3>
                <div className="animate-pulse text-purple-600 font-medium">
                    {waitingCallbackInfo && waitingCallbackInfo.send_callback_email === "yes" ? (
                        "Hvis du blir akseptert, vil du motta en lenke til samtalen via E-POST"
                    ) : (
                        "Hvis du blir akseptert, vil du motta en samtalelenke via SMS"
                    )}
                </div>
            </section>
        )
    }
}